import React from 'react';
import { X } from 'lucide-react';
interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function VideoModal({
  isOpen,
  onClose
}: VideoModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-352">
      <div className="relative w-full max-w-5xl bg-white rounded-lg shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-353">
        {/* Close Button */}
        <button onClick={onClose} className="absolute top-4 right-4 z-10 p-2 bg-black/50 hover:bg-black/70 text-white rounded-full transition-colors" aria-label="Close video" data-id="element-354">
          <X className="h-6 w-6" data-id="element-355" />
        </button>

        {/* Video Container */}
        <div className="relative w-full" style={{
        paddingBottom: '56.25%',
        height: 0
      }} data-id="element-356">
          <iframe style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0
        }} src="https://demo.linkdeal.ai/e/cmizu7naq001xl804208bx4xl/tour" allowFullScreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" data-id="element-357" />
        </div>
      </div>
    </div>;
}